// import { addNotification } from './ErrorActions';

export const PLAYER_SONG_SET = 'PLAYER_SONG_SET';
export const PLAYER_SONG_PAUSE = 'PLAYER_SONG_PAUSE';
export const PLAYER_SONG_SET_IS_LOADED = 'PLAYER_SONG_SET_IS_LOADED';
export const PLAYER_IS_SHOWN_TOGGLE = 'PLAYER_IS_SHOWN_TOGGLE';

function setPlayerSong(song) {
  playerSongPause();

  return {
    song,
    type: PLAYER_SONG_SET,
  };
}

function shouldFetchPlayerSong(state) {
  const posts = state.songPlayer;

  if (!posts) {
    return true;
  } else if (posts.isFetching) {
    return false;
  } else {
    return posts.didInvalidate;
  }
}

function playerIsShownToggle(pToggle) {
  return {
    show: pToggle,
    type: PLAYER_IS_SHOWN_TOGGLE,
  };
}

export function fetchPlayerSong(song) {
  return (dispatch, getState) => {
    if (shouldFetchPlayerSong(getState())) {

      if (song && song.product_file) {
        // dispatch(addNotification(`${song.product_file.post_title} playing.`, 'success'));
        dispatch(playerIsShownToggle(true));

        return dispatch(setPlayerSong(song));

      } else {
        // dispatch(addNotification('This song is being uploaded, wait for it to be available', 'warning'));
      }
    }
  };
}

export function playerSongPause() {
  return {
    shouldPause: true,
    type: PLAYER_SONG_PAUSE,
  };
}

export function playerSongPauseToggle(shouldPause) {
    return {
    shouldPause,
    type: PLAYER_SONG_PAUSE,
  };
}

export function playerSongSetIsLoaded() {
  return {
    shouldPlay: true,
    type: PLAYER_SONG_SET_IS_LOADED,
  };
}



// WEBPACK FOOTER //
// ./src/actions/PlayerActions.js